import { useState } from 'react';
import { cn } from '@playerbase/ui';

import { MembersPanel } from './studio-settings/members-panel.js';
import { StudioInformationPanel } from './studio-settings/studio-information-panel.js';

// Studio-scoped admin: Studio information and Members today, with Billing,
// Notifications etc landing here as the Studio Config epic ships them. The
// left rail is built to absorb those entries.

const sections = [
  { id: 'studio-information', label: 'Studio information' },
  { id: 'members', label: 'Members' },
] as const;

type SectionId = (typeof sections)[number]['id'];

export function StudioSettingsPage(): JSX.Element {
  const [activeSection, setActiveSection] = useState<SectionId>('studio-information');

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden md:flex-row">
      <nav
        aria-label="Studio settings navigation"
        className={cn(
          'shrink-0 border-border bg-surface',
          'border-b md:w-56 md:border-b-0 md:border-r',
          'md:h-full md:overflow-y-auto',
        )}
      >
        <p className="px-4 pt-5 pb-2 font-mono text-[10px] uppercase tracking-wider text-text-muted">
          Studio settings
        </p>
        <ul className="flex gap-1 overflow-x-auto px-2 pb-3 md:flex-col md:overflow-x-visible md:pb-4">
          {sections.map((s) => {
            const active = s.id === activeSection;
            return (
              <li key={s.id} className="md:w-full">
                <button
                  type="button"
                  onClick={() => setActiveSection(s.id)}
                  className={cn(
                    'block w-full whitespace-nowrap rounded-sm px-3 py-2 text-left text-sm transition-colors duration-150',
                    'border-l-2',
                    active
                      ? 'bg-accent-bg text-accent border-l-accent'
                      : 'border-transparent text-text-muted hover:text-text',
                  )}
                >
                  {s.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="min-w-0 flex-1 overflow-y-auto">
        {activeSection === 'studio-information' && <StudioInformationPanel />}
        {activeSection === 'members' && <MembersPanel />}
      </div>
    </div>
  );
}
